import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=897badac&scoped=true&"
import script from "./inbox.vue?vue&type=script&lang=js&"
export * from "./inbox.vue?vue&type=script&lang=js&"
import style0 from "./inbox.vue?vue&type=style&index=0&id=897badac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897badac",
  null
  
)

export default component.exports